var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"justify-content-center align-items-center ps-3"},[_c('div',[_c('div',[_vm._t("reportContainer")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }